import React, { useEffect } from "react";
import "./styles.scss";

import Input from "../../../common/Input";
import { InputLabel } from "@mui/material";
import { TextField, Autocomplete } from "@mui/material";

import { getBillingStateList } from "../../../store/homeAction/action";
import { useStateValue } from "../../../store";
import SkeletonLine from "../../../common/Skeletion/line";

const BillingInfo = ({
  setBillingData,
  billingData,
  setInputValidation,
  inputValidation,
  setBillingStateTrigger,
  billingStatetrigger,
}) => {
  const [{ countryList, stateListBilling }, dispatch] = useStateValue();

  useEffect(() => {
    if (countryList?.length && billingData?.billing_country) {
      const mail = sessionStorage.getItem("mail_checkout");
      let payload = {
        email: mail,
        session_key: sessionStorage.getItem("session_key"),
        billing_country: billingData?.billing_country?.country_id,
        billing_state: null,
      };
      setBillingStateTrigger(true);
      getBillingStateList((res) => {
        dispatch({
          type: "SET_CHECKOUT_BILLING_STATE",
          data: res?.data,
        });
        setBillingStateTrigger(false);
      }, payload);
    }
  }, [billingData?.billing_country]);

  useEffect(() => {
    if (stateListBilling?.states && billingData?.billing_state) {
      let temp = stateListBilling?.states?.filter(
        (item) => item?.state_id === billingData?.billing_state
      );
      if (temp?.length) {
        setBillingData((prev) => ({
          ...prev,
          billingData_state: temp?.[0],
        }));
      } else {
        setBillingData((prev) => ({
          ...prev,
          billing_state: billingData?.billing_state,
        }));
      }
    }
  }, [stateListBilling]);

  //change input
  const onHandleChange = (event) => {
    const { name, value } = event.target;
    setBillingData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setInputValidation((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  return (
    <div className="shipping-container">
      <div className="input-section">
        <p for="first_name">First name</p>
        <Input
          placeholder="Enter first name"
          value={billingData?.billing_first_name}
          id="billing_first_name"
          name="billing_first_name"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_first_name && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_first_name}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p for="last_name">Last name</p>
        <Input
          placeholder="Enter last name"
          value={billingData?.billing_last_name}
          name="billing_last_name"
          id="billing_last_name"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_last_name && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_last_name}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p for="phone_number">Phone number</p>
        <Input
          placeholder="Enter phone number"
          value={billingData?.billing_phone_number}
          name="billing_phone_number"
          id="billing_phone_number"
          type="number"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_phone_number && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_phone_number}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p for="company_name">
          Company name <span className="optional"> (optional)</span>
        </p>
        <Input
          placeholder="Enter company name"
          value={billingData?.billing_company_name}
          name="billing_company_name"
          id="billing_company_name"
          type="text"
          onChange={onHandleChange}
        />
      </div>
      <div className="input-section">
        <p for="address_1">Street address</p>
        <Input
          placeholder="Address line 01"
          value={billingData?.billing_address_1}
          name="billing_address_1"
          id="billing_address_1"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_address_1 && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_address_1}
          </InputLabel>
        )}
        <Input
          placeholder="Address line 02"
          style={{ marginTop: "16px" }}
          value={billingData?.billing_address_2}
          name="billing_address_2"
          id="billing_address_2"
          type="text"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_address_2 && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_address_2}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p for="postal_zip">Postal zip</p>
        <Input
          placeholder="Enter postal zip"
          value={billingData?.billing_postal_zip}
          name="billing_postal_zip"
          type="text"
          id="billing_postal_zip"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_postal_zip && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_postal_zip}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p for="city">Town / City</p>
        <Input
          placeholder="Enter town/city"
          value={billingData?.billing_city}
          name="billing_city"
          type="text"
          id="billing_city"
          onChange={onHandleChange}
        />
        {inputValidation?.billing_city && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_city}
          </InputLabel>
        )}
      </div>
      <div className="input-section">
        <p>Country / Region</p>
        <Autocomplete
          options={countryList}
          value={billingData?.billing_country}
          name="billing_country"
          onChange={(event, newValue) => {
            setBillingData((prev) => ({
              ...prev,
              billing_country: newValue,
              billing_state: "",
            }));

            setInputValidation((prevState) => ({
              ...prevState,
              billing_country: "",
            }));
          }}
          fullWidth
          getOptionLabel={(option) =>
            option.country_name ? option.country_name : ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label=""
              className="inputfield-box"
              placeholder="Select country/region"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
        {inputValidation?.billing_country && (
          <InputLabel className="validation_error">
            {inputValidation?.billing_country}
          </InputLabel>
        )}
      </div>
      {billingStatetrigger ? (
        <SkeletonLine style={{ height: "4vh", margin: "2px" }} />
      ) : stateListBilling?.states?.length ? (
        <div className="input-section">
          <p>Province / State</p>
          <Autocomplete
            options={stateListBilling?.states}
            value={billingData?.billing_state}
            name="billing_state"
            onChange={(event, newValue) => {
              setBillingData((prev) => ({
                ...prev,
                billing_state: newValue,
              }));

              setInputValidation((prevState) => ({
                ...prevState,
                billing_state: "",
              }));
            }}
            fullWidth
            getOptionLabel={(option) =>
              option?.state_name ? option?.state_name : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label=""
                className="inputfield-box"
                placeholder="Select province/state"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </div>
      ) : (
        <div className="input-section">
          <p for="state">Province / State</p>
          <Input
            placeholder="Enter province/state"
            value={
              billingData?.billingData_state?.state_name
                ? null
                : billingData?.billingData_state
            }
            name="billing_state"
            id="billing_state"
            type="text"
            onChange={onHandleChange}
          />

          {inputValidation?.billing_state && (
            <InputLabel className="validation_error">
              {inputValidation?.billing_state}
            </InputLabel>
          )}
        </div>
      )}
    </div>
  );
};

export default BillingInfo;
